<template>
  <div>
    <!-- 产品分类导航 -->
    <div class="nav_container">
      <div class="breadcrumb_section">
        <div class="breadcrumb_content">
          <span @click="$router.push('/')">{{ $t("Home") }}</span>
          <span class="separator">></span>
          <span class="current">{{ $t("Products Center") }}</span>
        </div>
      </div>
<!--      <div class="page_nav_div">-->
<!--        <p-->
<!--          v-for="(item, index) in categories"-->
<!--          :key="index"-->
<!--          :class="{ active: activeCategory === index }"-->
<!--          @click="selectCategory(index)"-->
<!--        >-->
<!--          {{ item.name }}-->
<!--        </p>-->
<!--      </div>-->
    </div>

    <!-- 产品列表 -->
    <div class="products_container">
      <!-- 左侧分类导航 -->
      <div class="category_sidebar">
        <!-- 移动端折叠头部 -->
        <div v-if="isMiniWindows" class="mobile_sidebar_header" @click="sidebarExpanded = !sidebarExpanded">
          <span class="header_text">{{ $t('所有产品') }}</span>
          <i :class="sidebarExpanded ? 'el-icon-minus' : 'el-icon-plus'"></i>
        </div>
<!--        <h3 class="category_title">{{ $t("产品分类") }}</h3>-->
        <div v-show="!isMiniWindows || sidebarExpanded" class="category_tree">
          <div
            v-for="(category, index) in categories"
            :key="category.id || index"
            class="category_item"
          >
            <div
              class="category_level1"
              :class="{ active: selectedCategoryId === category.id }"
              @click="selectCategory(category.id)"
            >
              <span class="category_name">{{ category.name }}</span>
              <span class="expand_icon">
                <i v-if="(category.subCategories && category.subCategories.length > 0 ) && !category.expanded" class="el-icon-plus"></i>
                <i v-else-if="(category.subCategories && category.subCategories.length > 0 ) && category.expanded" class="el-icon-minus"></i>
              </span>
            </div>
            <div v-if="category.expanded" class="category_level2">
              <div
                v-for="(subCategory, subIndex) in category.subCategories"
                :key="subCategory.id || subIndex"
                class="sub_category_item"
                :class="{ active: selectedSubCategoryId === subCategory.id }"
                @click="selectSubCategory(subCategory.id)"
              >
                {{ subCategory.name }}
              </div>
<!--              <div v-if="category.products && category.products.length > 0" class="category_products">-->
<!--                <div-->
<!--                  v-for="(product, pIndex) in category.products"-->
<!--                  :key="'p_' + pIndex"-->
<!--                  class="sub_category_item"-->
<!--                  @click="goToDetail(product.id)"-->
<!--                >-->
<!--                  {{ product.name }}-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧产品列表 -->
      <div class="products_main">
        <template v-if="showAllProducts || (selectedCategoryIndex >= 0 && categories[selectedCategoryIndex])">
          <div
            v-for="subCategory in filteredSubCategories"
            :key="subCategory.groupKey"
            class="product_group"
          >
            <p class="group_title">{{ subCategory.name }}</p>
          <div class="title_underline"></div>
          <div class="products_grid">
            <div
              v-for="(product, index) in groupedProducts[subCategory.groupKey] || []"
              :key="index"
              class="product_card"
              @click="goToDetail(product.id)"
              @mouseenter="hoveredCardIndex = `${subCategory.groupKey}_${index}`"
              @mouseleave="hoveredCardIndex = null"
            >
              <div class="product_img_wrapper">
                <img :src="product.image" :alt="product.name" />
              </div>
              <div class="product_info">
                <pre class="h3">{{ product.name }}</pre>
                <img
                  :src="hoveredCardIndex === `${subCategory.groupKey}_${index}` ? require('../../static/img/查看产品详情箭头-选中.png') : require('../../static/img/查看产品详情箭头-未选中.png')"
                  class="arrow_icon"
                  alt="arrow"
                />
              </div>
            </div>
          </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 分页 -->
<!--    <div class="pagination_wrapper">-->
<!--      <el-pagination-->
<!--        background-->
<!--        layout="prev, pager, next"-->
<!--        :total="total"-->
<!--        :page-size="pageSize"-->
<!--        @current-change="handlePageChange"-->
<!--      />-->
<!--    </div>-->
  </div>
</template>

<script>
import * as API from "@/api/index";

export default {
  data() {
    return {
      activeCategory: 0,
      categories: [],
      products: [],
      groupedProducts: {}, // 按二级分类ID分组的产品
      total: 50,
      pageSize: 8,
      currentPage: 1,
      isMiniWindows: false,
      clientWidth: 0,
      sidebarExpanded: false,
      selectedCategoryId: null,
      selectedSubCategoryId: null,
      hoveredCardIndex: null, // 用于跟踪鼠标悬停的卡片
      showAllProducts: false, // 是否显示所有产品（无分类选中时）
    };
  },
  computed: {
    filteredProducts() {
      return this.products;
    },
    selectedCategoryName() {
      if (!this.selectedCategoryId) return '';
      const cat = this.categories.find(c => c.id === this.selectedCategoryId);
      return cat ? cat.name : '';
    },
    selectedCategoryIndex() {
      return this.categories.findIndex(c => c.id === this.selectedCategoryId);
    },
    filteredSubCategories() {
      // 显示所有产品模式：汇总所有分类的二级分类，以及直接挂在一级分类下的产品分组
      if (this.showAllProducts) {
        const allSubs = [];
        this.categories.forEach(cat => {
          // 若一级分类下有直接产品（无二级分类），添加以一级分类自身为虚拟分组
          const categoryGroupKey = this.getCategoryGroupKey(cat.id);
          if (this.groupedProducts[categoryGroupKey] && this.groupedProducts[categoryGroupKey].length > 0) {
            allSubs.push({ id: cat.id, name: cat.name, groupKey: categoryGroupKey });
          }
          if (cat.subCategories && cat.subCategories.length > 0) {
            allSubs.push(...cat.subCategories);
          }
        });
        return allSubs;
      }
      if (this.selectedCategoryIndex < 0) return [];
      const cat = this.categories[this.selectedCategoryIndex];
      const subCategories = [];
      // 若该一级分类下有直接产品，添加以一级分类自身为虚拟分组
      const categoryGroupKey = this.getCategoryGroupKey(cat.id);
      if (this.groupedProducts[categoryGroupKey] && this.groupedProducts[categoryGroupKey].length > 0) {
        subCategories.push({ id: cat.id, name: cat.name, groupKey: categoryGroupKey });
      }
      subCategories.push(...(cat.subCategories || []));
      // 如果选中了二级分类，只显示该二级分类
      if (this.selectedSubCategoryId) {
        return subCategories.filter(sub =>
          sub.groupKey === this.getSubCategoryGroupKey(this.selectedSubCategoryId)
        );
      }
      // 否则显示所有二级分类及直接产品分组
      return subCategories;
    },
  },
  watch: {
    clientWidth(newVal) {
      this.isMiniWindows = newVal < 1200;
    },
    '$route.query.subParam'(newSubParam) {
      if (newSubParam) {
        this.selectedSubCategoryId = Number(newSubParam);
      } else {
        this.selectedSubCategoryId = null;
      }
    },
    '$route.query.param'(newParam) {
      if (newParam) {
        const targetId = Number(newParam);
        const targetIndex = this.categories.findIndex(cat => cat.id === targetId);
        if (targetIndex !== -1) {
          this.showAllProducts = false;
          // 折叠所有分类
          this.categories.forEach(cat => {
            this.$set(cat, 'expanded', false);
          });
          this.$set(this.categories[targetIndex], 'expanded', true);
          this.selectedCategoryId = this.categories[targetIndex].id;
          // 检查是否有二级分类参数
          const subParam = this.$route.query.subParam;
          if (subParam) {
            this.selectedSubCategoryId = Number(subParam);
          } else {
            this.selectedSubCategoryId = null;
          }
          this.getProductsByCategory(this.categories[targetIndex].id);
        }
      } else {
        // 无参数，显示所有产品
        this.showAllProducts = true;
        this.selectedCategoryId = null;
        this.selectedSubCategoryId = null;
        this.categories.forEach(cat => {
          this.$set(cat, 'expanded', false);
        });
        this.loadAllProducts();
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    let that = this;
    var clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    that.clientWidth = clientWidth;
    that.isMiniWindows = clientWidth < 1200;

    this.getProductCategoryData();

    window.onresize = () => {
      return (() => {
        var clientWidth =
          document.documentElement.clientWidth || document.body.clientWidth;
        that.clientWidth = clientWidth;
      })();
    };
  },
  methods: {
    getCategoryGroupKey(categoryId) {
      return `category_${categoryId}`;
    },
    getSubCategoryGroupKey(subCategoryId) {
      return `subcategory_${subCategoryId}`;
    },
    selectCategory(categoryId) {
      const categoryIndex = this.categories.findIndex(c => c.id === categoryId);
      const category = this.categories[categoryIndex];

      // 如果点击的是已选中且已展开的分类，则折叠
      if (this.selectedCategoryId === categoryId && category.expanded) {
        this.$set(this.categories[categoryIndex], 'expanded', false);
        return;
      }

      this.showAllProducts = false;
      this.selectedCategoryId = categoryId;
      this.selectedSubCategoryId = null;

      // 先折叠所有其他分类（手风琴效果）
      this.categories.forEach((cat, idx) => {
        if (idx !== categoryIndex && cat.expanded) {
          this.$set(this.categories[idx], 'expanded', false);
        }
      });

      // 展开当前分类 - 使用 $set 确保响应式更新
      this.$set(this.categories[categoryIndex], 'expanded', true);

      // 加载该大类的产品到侧边栏
      this.loadCategoryProducts(categoryIndex, categoryId);

      // 加载右侧显示的产品
      this.getProductsByCategory(categoryId);
    },
    selectSubCategory(subCategoryId) {
      this.selectedSubCategoryId = subCategoryId;
      // 根据二级分类ID筛选产品显示
      // 产品已经按一级分类加载，这里只需要更新选中状态，computed会自动过滤显示
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getProductListData();
    },
    goToDetail(id) {
      this.$router.push(`/ProductsDetail/${id}`);
    },
    // 获取多语言字段
    getLocalizedField(item, field) {
      var result = this.$getI18nField(item, field);
      if(field==='name'||field==='title') {
        result = result.replace(";","\n");
      }
      return result
    },
    // 获取产品分类（一级分类）
    async getProductCategoryData() {
      try {
        const res = await API.getProductCategoryList({ page: 1, limit: 100 });
        if (res.code === 0 && res.page && res.page.list) {
          this.categories = res.page.list.map(item => ({
            id: item.id,
            name: this.getLocalizedField(item, 'title'),
            value: item.id,
            image: item.image,
            expanded: false,
            subCategories: [],
            products: [],
            ...item
          }));

          // 为所有分类获取二级分类
          await Promise.all(this.categories.map((category, index) =>
            this.getSubCategories(index, category.id)
          ));

          // 为所有分类加载产品到侧边栏
          await Promise.all(this.categories.map((category, index) =>
            this.loadCategoryProducts(index, category.id)
          ));

          // 读取路由参数，判断是否指定了分类
          const paramCategoryId = this.$route.query.param;

          if (paramCategoryId) {
            // 从导航栏菜单点击了具体分类项，展开对应分类
            const targetId = Number(paramCategoryId);
            const targetIndex = this.categories.findIndex(cat => cat.id === targetId);
            if (targetIndex !== -1) {
              this.categories[targetIndex].expanded = true;
              this.selectedCategoryId = this.categories[targetIndex].id;
              this.getProductsByCategory(this.categories[targetIndex].id);
              // 如果有二级分类参数，选中对应的二级分类
              const paramSubCategoryId = this.$route.query.subParam;
              if (paramSubCategoryId) {
                this.selectedSubCategoryId = Number(paramSubCategoryId);
              }
            } else if (this.categories.length > 0) {
              // 参数无效，回退到显示所有产品
              this.showAllProducts = true;
              this.loadAllProducts();
            }
          } else {
            // 直接点击导航栏"Product"标题，不展开任何分类，显示所有产品
            this.showAllProducts = true;
            this.loadAllProducts();
          }
        }
      } catch (error) {
        this.initDefaultCategories();
      }
    },
    // 获取产品二级分类
    getSubCategories(categoryIndex, categoryId) {
      return new Promise((resolve) => {
        API.getProductSubCategoryList({ categoryId: categoryId, page: 1, limit: 100 })
          .then((res) => {
            if (res.code === 0 && res.page && res.page.list) {
              // 使用 $set 确保响应式更新
              this.$set(this.categories[categoryIndex], 'subCategories', res.page.list.map(item => ({
                id: item.id,
                name: this.getLocalizedField(item, 'title'),
                categoryId: item.categoryId,
                groupKey: this.getSubCategoryGroupKey(item.id)
              })));
            }
            resolve();
          })
          .catch(() => {
            this.$set(this.categories[categoryIndex], 'subCategories', []);
            resolve();
          });
      });
    },
    // 加载大类的产品到侧边栏
    loadCategoryProducts(categoryIndex, categoryId) {
      API.getProductListByCategory(categoryId)
        .then((res) => {
          if (res.code === 0 && res.list) {
            const products = res.list
              .filter(item => !item.subCategoryId)
              .map(item => {
              let image = require("../../static/img/logo.png");
              if (item.images) {
                try {
                  const images = JSON.parse(item.images);
                  if (images && images.length > 0) {
                    image = images[0];
                  }
                } catch (e) {}
              }
              return {
                id: item.id,
                name: this.getLocalizedField(item, 'name'),
                image: image
              };
            });
            this.$set(this.categories[categoryIndex], 'products', products);
          }
        })
        .catch(() => {
          this.$set(this.categories[categoryIndex], 'products', []);
        });
    },
    // 根据分类ID获取产品列表
    getProductsByCategory(categoryId) {
      API.getProductListByCategory(categoryId)
        .then((res) => {
          if (res.code === 0 && res.list) {
            this.products = res.list.map(item => {
              // 解析images字段
              let image = require("../../static/img/logo.png");
              if (item.images) {
                try {
                  const images = JSON.parse(item.images);
                  if (images && images.length > 0) {
                    image = images[0];
                  }
                } catch (e) {
                  // 解析失败使用默认图片
                }
              }
              return {
                id: item.id,
                name: this.getLocalizedField(item, 'name'),
                description: this.getLocalizedField(item, 'introduction'),
                image: image,
                categoryId: item.categoryId,
                subCategoryId: item.subCategoryId || null,
                groupKey: item.subCategoryId
                  ? this.getSubCategoryGroupKey(item.subCategoryId)
                  : this.getCategoryGroupKey(item.categoryId)
              };
            });
            // 按二级分类ID分组
            this.groupProductsBySubCategory();
            this.total = this.products.length;
          }
        })
        .catch(() => {
          this.initProducts();
        });
    },
    // 加载所有分类的产品
    async loadAllProducts() {
      const allProducts = [];
      await Promise.all(this.categories.map(category =>
        API.getProductListByCategory(category.id)
          .then((res) => {
            if (res.code === 0 && res.list) {
              res.list.forEach(item => {
                let image = require("../../static/img/logo.png");
                if (item.images) {
                  try {
                    const images = JSON.parse(item.images);
                    if (images && images.length > 0) {
                      image = images[0];
                    }
                  } catch (e) {}
                }
                allProducts.push({
                  id: item.id,
                  name: this.getLocalizedField(item, 'name'),
                  description: this.getLocalizedField(item, 'introduction'),
                  image: image,
                  categoryId: item.categoryId,
                  subCategoryId: item.subCategoryId || null,
                  groupKey: item.subCategoryId
                    ? this.getSubCategoryGroupKey(item.subCategoryId)
                    : this.getCategoryGroupKey(item.categoryId)
                });
              });
            }
          })
          .catch(() => {})
      ));
      this.products = allProducts;
      this.groupProductsBySubCategory();
      this.total = this.products.length;
    },
    // 按二级分类分组产品
    groupProductsBySubCategory() {
      const grouped = {};
      this.products.forEach(product => {
        const groupKey = product.groupKey;
        if (!grouped[groupKey]) {
          grouped[groupKey] = [];
        }
        grouped[groupKey].push(product);
      });
      this.groupedProducts = grouped;
    },
    // 获取产品列表
    getProductListData() {
      const categoryId = this.categories[this.activeCategory]?.value;
      const params = {
        page: this.currentPage,
        limit: this.pageSize
      };
      if (categoryId) {
        params.categoryId = categoryId;
      }

      API.getProductList(params)
        .then((res) => {
          if (res.code === 0 && res.page) {
            this.products = res.page.list.map(item => ({
              id: item.id,
              name: this.getLocalizedField(item, 'name'),
              description: this.getLocalizedField(item, 'description'),
              image: item.mainImage || require("../../static/img/logo.png"),
              category: item.categoryId
            }));
            this.total = res.page.totalCount;
          }
        })
        .catch(() => {
          this.initProducts();
        });
    },
    initDefaultCategories() {
      this.categories = [
        { id: 1, name: this.$t("光纤连接器"), value: "Connector", expanded: false, subCategories: [] },
        { id: 2, name: this.$t("光纤适配器"), value: "Adapter", expanded: false, subCategories: [] },
        { id: 3, name: this.$t("光纤衰减器"), value: "Attenuator", expanded: false, subCategories: [] },
        { id: 4, name: this.$t("光纤配线架"), value: "ODF", expanded: false, subCategories: [] },
        { id: 5, name: this.$t("其他产品"), value: "Others", expanded: false, subCategories: [] },
      ];
      if (this.categories.length > 0) {
        this.selectedCategoryId = this.categories[0].id;
      }
    },
    initProducts() {
      // 模拟产品数据（作为备用）
      this.products = [
        {
          id: 1,
          name: "SC/UPC 单工单模光纤跳线",
          description: "低插入损耗，高回波损耗，广泛应用于光纤通信系统",
          image: require("../../static/img/logo.png"),
          category: "Connector",
        },
        {
          id: 2,
          name: "LC/APC 双工多模光纤跳线",
          description: "采用精密陶瓷插芯，符合Telcordia标准",
          image: require("../../static/img/logo.png"),
          category: "Connector",
        },
        {
          id: 3,
          name: "FC/ST 铠装光纤跳线",
          description: "钢铠保护，适用于恶劣环境部署",
          image: require("../../static/img/logo.png"),
          category: "Connector",
        },
        {
          id: 4,
          name: "MPO/MTP 高密度光纤跳线",
          description: "8芯/12芯/24芯可选，适用于数据中心高密度布线",
          image: require("../../static/img/logo.png"),
          category: "Connector",
        },
        {
          id: 5,
          name: "SC 单工单模光纤适配器",
          description: "高精度对准，低插入损耗，符合IEC标准",
          image: require("../../static/img/logo.png"),
          category: "Adapter",
        },
        {
          id: 6,
          name: "LC 双工多模光纤适配器",
          description: "紧凑型设计，适用于高密度应用",
          image: require("../../static/img/logo.png"),
          category: "Adapter",
        },
        {
          id: 7,
          name: "固定式光纤衰减器",
          description: "精确衰减值，1dB-30dB可选",
          image: require("../../static/img/logo.png"),
          category: "Attenuator",
        },
        {
          id: 8,
          name: "可调式光纤衰减器",
          description: "0-60dB连续可调，适用于测试应用",
          image: require("../../static/img/logo.png"),
          category: "Attenuator",
        },
      ];
      this.total = 8;
    },
  },
};
</script>

<style lang="scss" scoped>
.top_img {
  padding: 0 12.5%;
  height: 47rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .title {
    text-align: left;
    font-size: 7rem;
    font-family: bold;
    color: white;
    margin: 7rem 0 0 0;
    align-self: flex-start;
  }

  .subtitle {
    text-align: left;
    font-size: 2rem;
    color: rgba(255, 255, 255, 0.7);
    margin-top: 1rem;
    letter-spacing: 1rem;
  }
}

.nav_container {
  display: flex;
  background: white;
  //border-bottom: 1px solid #BDC0C5;
  padding: 0 12.5% 0;
}

.breadcrumb_section {
  background: white;
  padding: 3rem 0 0;
  width: 50%;

  .breadcrumb_content {
    max-width: 140rem;
    margin: 0 auto;
    padding: 0;
    font-size: 1.8rem;
    color: #BDC0C5;
    text-align: left;
    font-family: regular;

    span {
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1d2087;
      }

      &.separator {
        margin: 0 1rem;
        color: #BDC0C5;
        cursor: default;
      }

      &.current {
        color: #1D2087;
        cursor: default;
      }
    }
  }
}

.page_nav_div {
  background: white;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  border: none;
  width: 50%;

  p {
    color: #5B6370;
    padding: 2rem 3rem;
    margin: 0 1rem;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    transition: all 0.3s;
    font-size: 1.6rem;

    &:hover,
    &.active {
      color: #1d2087;
      border-bottom-color: #1d2087;
    }
  }
}

.products_container {
  margin: 8rem 12.5%;
  padding: 0;
  display: flex;
  gap: 8.6rem;
}

.category_sidebar {
  width: 40rem;
  max-width: 40rem;
  box-sizing: border-box;
  height: fit-content;
  background: white;
  border-radius: 1.6rem;
  border: 1px solid #BDC0C5;
  padding: 3rem;
  box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.08);

  .mobile_sidebar_header {
    display: none;
  }

  .category_title {
    font-family: regular;
    font-size: 1.8rem;
    color: #212121;
    margin: 0 0 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #1d2087;
    text-align: left;
  }
}

.category_tree {
  .category_item {
    margin-bottom: 0.5rem;
    border-bottom:1px solid #8A9099;
    &:last-child{
      border-bottom: none;
    }
  }

  .category_level1 {
    display: flex;
    align-items: center;
    padding: 2.5rem 1rem;
    cursor: pointer;
    transition: all 0.3s;
    color: #5B6370;
    font-size: 1.6rem;

    &:hover {
      //background: rgba(29, 32, 135, 0.05);
      color: #1d2087;
      .category_name {
        color: #1d2087;
      }
    }

    &.active {
      //background: rgba(29, 32, 135, 0.1);
      color: #1d2087;
      .category_name {
        color: #1d2087;
      }
    }

    .expand_icon {
      width: 2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;
      color: #1d2087;
      font-weight: bold;

      i {
        font-size: 1.4rem;
      }
    }

    .category_name {
      text-align: left;
      flex: 1;
      font-size: 1.8rem;
      color: #212121;
      font-family: regular;
    }
  }

  .category_level2 {
    padding-left: 3rem;

    .sub_category_item {
      padding: 1rem 0;
      cursor: pointer;
      border-radius: 0.5rem;
      transition: all 0.3s;
      color: #212121;
      font-size: 1.8rem;
      text-align: left;
      font-family: regular;

      &:hover {
        //background: rgba(29, 32, 135, 0.05);
        color: #1D2087;
      }

      &.active {
        //background: rgba(29, 32, 135, 0.1);
        color: #1D2087;
      }
    }

    .category_products {
      margin-top: 0;
      padding-top: 0;
    }
  }
}

.products_main {
  width: max-content;
  flex: 1;
}

.product_group {
  margin-bottom: 10rem;

  .group_title {
    font-family: bold;
    font-size: 3.8rem;
    color: #212121;
    margin: 0 0 2rem;
    padding-bottom: 1rem;
    text-align: left;
  }

  .title_underline {
    width: 8rem;
    height: 0.8rem;
    background-color: #1D2087;
    margin-bottom: 5.6rem;
  }
}

.products_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
}

.product_card {
  width:30rem;
  background: white;
  border-radius: 1.6rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    .product_img_wrapper {
      box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
      border: 1px solid #1D2087;
    }
  }
}

.product_img_wrapper {
  width: 100%;
  height: auto;
  padding: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #BDC0C5;
  border-radius: 1.6rem;

  img {
    width: auto;
    max-width: 100%;
    height: 27rem;
    object-fit: contain;
    transition: transform 0.3s;
    border-radius: 1.6rem;
  }
}

.product_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;

  .h3 {
    font-family: medium;
    font-size: 1.8rem;
    color: #5B6370;
    margin: 0;
    line-height: 2.3rem;
    text-align: left;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .arrow_icon {
    width: 2.8rem;
    height: 2.8rem;
    margin-left: 1rem;
  }

  .product_desc {
    font-size: 1.4rem;
    color: $color5E;
    line-height: 1.6;
    margin-bottom: 1.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .more_btn {
    display: inline-block;
    color: $textBlueColor;
    font-size: 1.4rem;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.pagination_wrapper {
  display: flex;
  justify-content: center;
  padding: 3rem 0 5rem;
}

@media (max-width: 1200px) {
  .top_img {
    height: 30rem;

    .title {
      font-size: 3.5rem;
    }

    .subtitle {
      font-size: 1.4rem;
      letter-spacing: 0.5rem;
    }
  }

  .page_nav_div {
    flex-wrap: wrap;
    padding: 1rem;
    width: 50%;
    justify-content: flex-end;

    p {
      padding: 1rem 1.5rem;
      font-size: 1.4rem;
    }
  }

  .nav_container {
    flex-direction: column;
    padding: 0;
  }

  .breadcrumb_section {
    width: 100%;
    padding: 1rem 0 0;
  }

  .products_container {
    flex-direction: column;
    margin: 4rem 5%;
  }

  .category_sidebar {
    width: 100%;
    margin-bottom: 3rem;
    padding: 0;

    .mobile_sidebar_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2rem 3rem;
      cursor: pointer;

      .header_text {
        font-size: 1.8rem;
        color: #212121;
        font-family: regular;
      }

      i {
        font-size: 1.6rem;
        color: #1d2087;
        font-weight: bold;
      }
    }

    .category_tree {
      padding: 0 3rem 2rem;
    }
  }

  .products_main {
    width: 100%;
  }

  .products_grid {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 2rem;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 1rem;

    &::-webkit-scrollbar {
      height: 0.6rem;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 1rem;
    }

    &::-webkit-scrollbar-thumb {
      background: #1D2087;
      border-radius: 1rem;
    }
  }

  .product_card {
    flex: 0 0 28rem;
    min-width: 28rem;
  }

  .product_img_wrapper {
    width: 28rem;
    height: 15rem;
  }
}

@media (max-width: 768px) {
  .top_img {
    padding: 0 2rem;
    height: 30rem;
    display: flex;

    .title {
      font-size: 3rem;
      margin: 5rem 0 0 0;
    }

    .subtitle {
      font-size: 1.2rem;
      margin-top: 0.5rem;
    }
  }

  .nav_container {
    padding: 0;
    display: flex;
  }

  .breadcrumb_section {
    padding: 2rem 2rem 0;
  }

  .products_container {
    margin: 3rem 2rem;
    display: flex;
    gap: 2rem;
  }

  .category_sidebar {
    padding: 0;

    .category_title {
      font-size: 1.6rem;
      margin: 0 0 1.5rem;
    }
  }

  .category_tree {
    .category_level1 {
      padding: 1.5rem 0.5rem;
      font-size: 1.4rem;

      .category_name {
        font-size: 1.6rem;
      }
    }

    .category_level2 {
      padding-left: 2rem;

      .sub_category_item {
        font-size: 1.6rem;
        padding: 0.8rem 0;
      }
    }
  }

  .product_group {
    margin-bottom: 6rem;

    .group_title {
      font-size: 2.5rem;
      margin: 0 0 1rem;
    }

    .title_underline {
      margin-bottom: 3rem;
      width: 5rem;
    }
  }

  .products_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    overflow: visible;
  }

  .product_card {
    width: 100%;
    flex: none;
    min-width: auto;
  }

  .product_img_wrapper {
    width: 100%;
    height: 14rem;
    img{
      object-fit: contain;
      height: 100%;
    }
  }

  .product_info {
    padding: 1.5rem 0;

    .h3 {
      font-size: 1.6rem;
    }
  }
}
</style>
